export function getApprovedDownloadableSku(requests, downloadSkus) {
	var approvedRequestSkus = requests
		.filter(rq => rq.status === 'approved')
		.map(item => item.sku);

	return approvedRequestSkus.filter(function(item) {
		return !downloadSkus.includes(item);
	});
}

export function getDownloadedReviewedSku(downloadSkus, reviewedSkus) {
	var downloadedReviewedSkus =
		downloadSkus &&
		downloadSkus.filter(function(item) {
			return reviewedSkus && reviewedSkus.includes(item);
		});

	return downloadedReviewedSkus || [];
}

export function getDownloadedNotReviewedSku(downloadSkus, reviewedSkus) {
	var downloadedNotReviewedSkus =
		downloadSkus &&
		downloadSkus.filter(function(item) {
			return !reviewedSkus || !reviewedSkus.includes(item);
		});

	return downloadedNotReviewedSkus || [];
}

export function getDeclinedSku(requests) {
	return requests
		.filter(rq => rq.status === 'rejected')
		.map(item => item.sku);
}

export function getPendingSku(requests) {
	return requests.filter(rq => !rq.status).map(item => item.sku);
}
